if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.expandColors();
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent('product-info:loaded', {bubbles: true}),
        );
      }

      expandColors() {
        this.colorExpanders = this.querySelectorAll(
          '.category-product-expand-action',
        );
        this.colorExpanders.forEach((expander) => {
          expander.addEventListener('click', () => {
            var category = expander.dataset.category;
            var categoryProducts = this.querySelectorAll(
              `[data-category-item="${category}"]`,
            );
            categoryProducts.forEach((product) => {
              product.classList.remove('hidden');
            });
            expander.classList.add('hidden');
          });
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll('.scroll-trigger')
            .forEach((element) =>
              element.classList.add('scroll-trigger--cancel'),
            ),
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({data: {event, target, selectedOptionValues}}) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        var productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        var shouldSwapProduct = this.dataset.url !== productUrl;
        var shouldFetchFullPage =
          this.dataset.updateUrl === 'true' && shouldSwapProduct;
        var badgeSoldout = document.querySelector('.badge-soldout');
        if(badgeSoldout != null){
          target.classList.contains('disabled')
          ? badgeSoldout.classList.remove('hidden')
          : badgeSoldout.classList.add('hidden');
        }

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage,
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        var productForm = this.productForm;
        //productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          var selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : 'product-info';
          var variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML =
              html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          }
        };
      }

      renderProductInfo({requestUrl, targetId, callback}) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, {signal: this.abortController.signal})
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            var html = new DOMParser().parseFromString(
              responseText,
              'text/html',
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        var selectedVariant = productInfoNode.querySelector(
          'variant-selects [data-selected-variant]',
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false,
      ) {
        var params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        var variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks,
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          var variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          //console.log(variant);
          if (variant.available) {
            document
              .querySelector('.product-notify-with-similar')
              ?.classList.add('hidden');
            this.querySelectorAll('.product-form__submit').forEach(
              (element) => {
                element?.classList.remove('hidden');
              },
            );
          } else {
            document
              .querySelector('.product-notify-with-similar')
              ?.classList.remove('hidden');
            this.querySelectorAll('.product-form__submit').forEach(
              (element) => {
                element?.classList.add('hidden');
              },
            );
          }
          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          var updateSourceFromDestination = (
            id,
            shouldHide = (source) => false,
          ) => {
            if (id === 'price') {
              var source = html.getElementById(`${id}-${this.sectionId}`);
              var destination = document.querySelectorAll(
                '.product-info-price',
              );
              if (source && destination.length > 0) {
                destination.forEach((element) => {
                  element.innerHTML = source.innerHTML;
                  element.classList.toggle('hidden', shouldHide(source));
                });
              }
            } else if (id === 'installments_text') {
              var source = html.getElementById(`${id}-${this.sectionId}`);
              var destination =
                document.querySelectorAll('.installments_text');
              if (source && destination.length > 0) {
                destination.forEach((element) => {
                  element.innerHTML = source.innerHTML;
                  element.classList.toggle('hidden', shouldHide(source));
                });
              }
            } else {
              var source = html.getElementById(`${id}-${this.sectionId}`);
              var destination = this.querySelector(
                `#${id}-${this.dataset.section}`,
              );
              if (source && destination) {
                destination.innerHTML = source.innerHTML;
                destination.classList.toggle('hidden', shouldHide(source));
              }
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('installments_text');
          updateSourceFromDestination('Sku', ({classList}) =>
            classList.contains('hidden'),
          );
          updateSourceFromDestination(
            'Inventory',
            ({innerText}) => innerText === '',
          );
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({classList}) =>
            classList.contains('hidden'),
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`,
          )?.classList.remove('hidden');
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`,
          )?.classList.remove('hidden');

          // this.productForm?.toggleSubmitButton(
          //   html
          //     .getElementById(`ProductSubmitButton-${this.sectionId}`)
          //     ?.hasAttribute('disabled') ?? true,
          //   window.variantStrings.soldOut,
          // );

          var stickyAddToCartButton = document.querySelector(
            '.sticky-add-to-cart',
          );
          //console.log(stickyAddToCartButton);
          if (stickyAddToCartButton) {
            var isDisabled =
              html
                .getElementById(`ProductSubmitButton-${this.sectionId}`)
                ?.hasAttribute('disabled') ?? true;
            var isPreOrder =  html
            .getElementById(`ProductSubmitButton-${this.sectionId}`)
            ?.classList.contains('product-pre-order') ?? true;

            if (isDisabled) {
              var stickySelect = document.querySelector('.sticky-select');
              if (isPreOrder) {
                const acceptsInput = document.querySelector('#accepts_pre_order_product');
                stickyAddToCartButton.classList.remove('hidden');
                if (acceptsInput ) {
                  if (acceptsInput.checked) {
                    stickyAddToCartButton.removeAttribute('disabled')
                  } else {
                    stickyAddToCartButton.disabled = true;
                  }
                } 
                
                if (stickySelect) {
                  stickySelect.classList.add('hide');
                }
              } else {
                stickyAddToCartButton.classList.add('hidden');
                if (stickySelect) {
                  stickySelect.classList.remove('hide');
                  stickySelect.classList.remove('show');
                  stickySelect.querySelector('span').textContent =
                    window.variantStrings.notify_me;
                }
              }
              
            } else {
              stickyAddToCartButton.classList.remove('hidden');
              stickyAddToCartButton.disabled = false;
            }
            stickyAddToCartButton.querySelector('span').textContent = isDisabled
              ? isPreOrder ? window.variantStrings.preOrder :
                            window.variantStrings.soldOut
              : window.variantStrings.addToCart;

            stickyAddToCartButton.setAttribute(
              'aria-label',
              isDisabled
                ? isPreOrder ? window.variantStrings.preOrder :
                              window.variantStrings.soldOut
                : window.variantStrings.addToCart,
            );
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        ).forEach((productForm) => {
          var input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', {bubbles: true}));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`,
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState(
          {},
          '',
          `${url}${variantId ? `?variant=${variantId}` : ''}`,
        );
      }

      setUnavailable() {
        // this.productForm?.toggleSubmitButton(
        //   true,
        //   window.variantStrings.unavailable,
        // );

        var selectors = [
          'price',
          'Inventory',
          'Sku',
          'Price-Per-Item',
          'Volume-Note',
          'Volume',
          'Quantity-Rules',
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document
          .querySelectorAll(selectors)
          .forEach(({classList}) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        var mediaGallerySource = this.querySelector('media-gallery ul');
        var mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        var refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          var mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll('li[data-media-id]'),
          );
          var sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId),
          );
          var sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              {item, index},
            ]),
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          var mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]'),
          );
          var destinationSet = new Set(
            mediaGalleryDestinationItems.map(({dataset}) => dataset.mediaId),
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              var sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`,
                  ),
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            },
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true,
        );

        // update media modal
        var modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`,
        );
        var newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`,
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        var data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        var max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        var currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          '.quantity__rules-cart .loading__spinner',
        ).classList.remove('hidden');
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            var html = new DOMParser().parseFromString(
              responseText,
              'text/html',
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              '.quantity__rules-cart .loading__spinner',
            ).classList.add('hidden'),
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        var quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        var selectors = [
          '.quantity__input',
          '.quantity__rules',
          '.quantity__label',
        ];
        for (let selector of selectors) {
          var current = this.quantityForm.querySelector(selector);
          var updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            var attributes = [
              'data-cart-quantity',
              'data-min',
              'data-max',
              'step',
            ];
            for (let attribute of attributes) {
              var valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        var relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products',
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`,
        );
      }

      get quickOrderList() {
        var quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list',
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`,
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    },
  );
}

// document.addEventListener('DOMContentLoaded', () => {
  // Get URL parameters
  var urlParams = new URLSearchParams(window.location.search);
  var variantId = urlParams.get('variant');

  // Deselect all original radio buttons if no variant is provided
  if (!variantId) {
    var radioButtons = document.querySelectorAll(
      '.full-width-main-product .original-radios [type="radio"]',
    );
    radioButtons.forEach((radio) => {
      radio.checked = false;
      radio.dispatchEvent(new Event('change')); // Trigger change event if needed
    });
  }

  // Cache selectors for better performance
  var customRadios = document.querySelectorAll(
    '.full-width-main-product .custom-radios [type="radio"] + label',
  );
  var originalRadios = document.querySelectorAll(
    '.full-width-main-product .original-radios [type="radio"]',
  );
  var numberOfOptions = document.querySelectorAll(
    '.full-width-main-product .product-form__input:not([hidden])',
  ).length;

  // Attach click event listeners to custom radio labels
  customRadios.forEach((label) => {
    label.addEventListener('click', (e) => {
      var selectedOptionVal = e.target.getAttribute('data-value');
      if (!selectedOptionVal) return;

      // Select the corresponding custom radio
      var customRadio = document.querySelector(
        `.full-width-main-product .custom-radios [type="radio"][value="${selectedOptionVal}"]`,
      );
      if (customRadio) {
        customRadio.checked = true;
        customRadio.classList.add('selected-option');
      }

      // Select the corresponding original radio
      var originalRadio = document.querySelector(
        `.full-width-main-product .original-radios [type="radio"][value="${selectedOptionVal}"]`,
      );
      if (originalRadio) {
        originalRadio.checked = true;
      }

      // Check if all options are selected
      var selectedOptions = document.querySelectorAll(
        '.full-width-main-product .original-radios [type="radio"]:checked',
      );
      //console.log(selectedOptions.length, numberOfOptions);
      if (selectedOptions.length === numberOfOptions) {
        // Trigger change event on the variant selector after a delay
        setTimeout(() => {
          var variantSelect = document.querySelector(
            '.full-width-main-product variant-selects',
          );
          if (variantSelect) {
            variantSelect.dispatchEvent(new Event('change'));
          }
        }, 500);
      }
    });
  });
// });
